/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITabViewProps } from './tab';

const tabView: React.FC<ITabViewProps> = props => {
    const { heading, TabContainer, tabHeaders, tabContents } = props;
    if (!props.heading && !props.tabHeaders && !props.tabContents) {
        props.context.telemetry.error('Tab content is empty, module wont render');
        return null;
    }
    return (
        <Module {...TabContainer}>
            <Node {...props.headerSection}>{heading}</Node>
            <Node {...props.tabsSection}>{tabHeaders}</Node>
            <Node {...props.tabItemContainer}>{tabContents}</Node>
        </Module>
    );
};

export default tabView;
